export default __webpack_public_path__ + "static/media/bugLBIcon.45e3f9a9.svg";